import _ from "lodash";
import { DEBUG_MODE, debugLog } from "utils/debug";

export const objectsEqual = (stagedObj, publishedObj, blacklistedKeys = []) => {
  let differences = [];
  for (const key of Object.keys(stagedObj)) {
    if (blacklistedKeys.includes(key)) continue;
    const equal = _.isEqual(stagedObj[key], publishedObj[key]);
    const empty = _.isEmpty(stagedObj[key]) && _.isEmpty(publishedObj[key]);
    if (!equal && !empty) {
      if (DEBUG_MODE) differences.push(key);
      else return false;
    }
  }
  if (differences.length > 0) {
    debugLog(
      "Values differ between staged and published objects",
      stagedObj,
      publishedObj
    );
    differences.forEach((key) => {
      debugLog(
        `key: "${key}"`,
        `Staged value: "${stagedObj[key]}"`,
        `Published value: "${publishedObj[key]}"`
      );
    });
    return false;
  } else return true;
};

export const questionsEqual = (stagedQuestions, publishedQuestions) => {
  let questionDifferences = [];
  if (stagedQuestions.length !== publishedQuestions.length) {
    debugLog(
      "Number of questions in staged and published survey differ:",
      `${stagedQuestions.length} != ${publishedQuestions.length}`
    );
    return false;
  }
  for (const idx in stagedQuestions) {
    const stagedQ = stagedQuestions[idx];
    const publishedQ = publishedQuestions[idx];
    const equal = objectsEqual(stagedQ, publishedQ, ["options", "fixed"]);
    if (equal) {
      const stagedQOptions = stagedQ.options.map((o) => o.text);
      const stagedQFixed = stagedQ.options.map((o) => o.fixed);
      const stagedQMutuallyExclusive = stagedQ.options.map((o) => o.mutuallyExclusive ?? false);
      const optionsEqual = _.isEqual(stagedQOptions, publishedQ.options);
      const fixedEqual = _.isEqual(stagedQFixed, publishedQ.fixed);
      const publishedQMutuallyExclusive = publishedQ.options.map(
        (_o, i) => publishedQ.optionProps?.[i]?.mutuallyExclusive ?? false
      );
      const mutuallyExclusiveEqual = _.isEqual(
        stagedQMutuallyExclusive,
        publishedQMutuallyExclusive
      );
      if (!optionsEqual || !fixedEqual || !mutuallyExclusiveEqual) {
        debugLog(`Options for question ${idx} differ`);
        if (DEBUG_MODE) questionDifferences.push(idx);
        else return false;
      }
    } else {
      if (DEBUG_MODE) questionDifferences.push(idx);
      else return false;
    }
  }
  if (questionDifferences.length > 0) {
    debugLog(
      `${questionDifferences.length} questions differ.`,
      "Indices of question that differ are",
      questionDifferences
    );
    return questionDifferences.length === 0;
  } else return true;
};
